export const extractPricingId = (frequency, pricings) => {
  return pricings.find((pricing) => pricing.frequency === frequency).id;
};
